/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Sample
 */
export interface Sample {
    /**
     * 
     * @type {number}
     * @memberof Sample
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Sample
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Sample
     */
    description?: string;
}

/**
 * Check if a given object implements the Sample interface.
 */
export function instanceOfSample(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function SampleFromJSON(json: any): Sample {
    return SampleFromJSONTyped(json, false);
}

export function SampleFromJSONTyped(json: any, ignoreDiscriminator: boolean): Sample {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['Id'],
        'name': json['Name'],
        'description': !exists(json, 'Description') ? undefined : json['Description'],
    };
}

export function SampleToJSON(value?: Sample | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'Name': value.name,
        'Description': value.description,
    };
}

